<script setup>
// Components
import Button from '@/Components/Button/Button.vue';
import ImgMedia from '@/Components/Images/ImgMedia.vue';

const props = defineProps({
    title: String,
    text: String,
    image: Object,
    color: String,
    button_label: String,
    external_url: String,
    intended_url: String,
    page_id: String,
});
</script>
<template>
    <div class="relative min-h-[450px] overflow-hidden bg-gray-light xl:min-h-[500px]">
        <div
            v-if="image"
            class="absolute left-0 top-0 z-20 h-full w-full"
        />

        <ImgMedia
            v-if="image"
            :media="image"
            :classes="'object-cover w-full h-[500px] xl:h-[550px] absolute top-0 left-0 z-10'"
        />

        <div class="container relative z-30">
            <div class="flex min-h-[500px] items-center xl:min-h-[550px]">
                <div class="lg:w-1/2">
                    <h1
                        v-if="title"
                        :style="[color? 'color: ' + color + '!important': '']"
                        :class="{ 'text-bodyColor': !image, 'text-white': image }"
                    >
                        {{ title }} 
                    </h1>

                    <div
                        v-if="text"
                        class="prose"
                        :class="{ 'text-bodyColor': !image, 'text-white': image }"
                        v-html="text"
                    />

                    <Button
                        v-if="button_label && intended_url"
                        :label="button_label"
                        :href="intended_url"
                        :external="!!external_url"
                        class="relative z-30 mt-8 w-auto"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
